import { CSSProperties } from "react";
import { css, getGraphColor } from "../../Styles";

export default function getComponentStyle(id?: string | number): CSSProperties | undefined {
  if (!id) return undefined;
  const { graphColor, textColor } = getGraphColor(+id);

  return {
    ...css.componentLabel,
    backgroundColor: graphColor,
    color: textColor
  };
};